// extracted by mini-css-extract-plugin
export var pageFeatureIcons = "ContentfulBlockFeatureIcons-module--pageFeatureIcons--NZ8VS";
export var featureWrapper = "ContentfulBlockFeatureIcons-module--featureWrapper--pEWsY";
export var featureImg = "ContentfulBlockFeatureIcons-module--featureImg--nYv7v";
export var featureTitleContainer = "ContentfulBlockFeatureIcons-module--featureTitleContainer--Ehcwz";
export var featureTitle = "ContentfulBlockFeatureIcons-module--featureTitle--OVVEN";
export var featureDesc = "ContentfulBlockFeatureIcons-module--featureDesc--OMjH4";